export default __webpack_public_path__ + "static/media/UN Somos Campus 2016-MEDIA-0432-2.64b98d3c.jpg";